import React from "react";
import "./Header.css";

export default function Header() {
    return (
        <div className="header-container">
            <div className="header-parent">
                <div className="header-title">
                    <h1>
                        Contact Me
                    </h1>
                </div>
                <div className="header-subtitle">
                    <h1>
                        Have any inquiries?
                    </h1>
                </div>
            </div>
        </div>
    )
}